// extracted by mini-css-extract-plugin
export default {"root":"Lglxy0","container":"DReImw","divider":"k2IR5S"};